import React from 'react'
import { withStyles } from '@material-ui/core/styles'
import { homeColors } from '../../tokens'
import styles from './styles'

/**
 * One bar per launch step; done steps and the current step are filled.
 */
const LaunchProgress = ({ classes, steps }) => (
  <div
    className={classes.root}
    role="progressbar"
    aria-valuemin={0}
    aria-valuemax={steps.length}
    aria-valuenow={steps.filter(step => step.done).length}
  >
    {steps.map(step => (
      <span
        key={step.id}
        className={classes.bar}
        style={{
          background:
            step.done || step.current ? homeColors.primary : homeColors.barIdle,
        }}
      />
    ))}
  </div>
)

export default withStyles(styles)(LaunchProgress)
